import type { CustomTimestamps } from 'chessboard/api/custom-timestamps/config/types';
import { MIN_MOVE_TIME } from 'config/game';
import { toRoundedDeciseconds } from 'chessboard/api/custom-timestamps/model/to-rounded-deciseconds';

/**
 * Get a valid timestamp.
 */
export function getValidTimestamp(
  timestamp: CustomTimestamps.Timestamp,
  unit: CustomTimestamps.Units,
): number | null {
  /**
   * Timestamps should always be in deciseconds for the VML to display them correctly.
   * Here we also ensure that a timestamp is at least 1 decisecond.
   */
  return timestamp === null
    ? null
    : Math.max(MIN_MOVE_TIME, toRoundedDeciseconds(<number>timestamp, unit));
}
